/**
 * Awtomic Cart Rollup v1.2.1 — SINGLE FILE BUILD
 * Generated by build-cart-extras.js — do not edit by hand.
 * Source: assets/awtomic-theme-definitions.js + assets/awtomic-cart-extras.js
 * Built: 2026-09-24T02:25:47.804Z
 */

(function () {
  var s = document.createElement('style');
  s.id = 'awtomic-cart-extras-css';
  s.textContent = "/**\n * Awtomic Cart Rollup - Styles\n * Version: 1.0.0\n */\n\n/* Prevent flash of unstyled content */\n.cart-items__table:not(.awtomic-ready) tbody tr[data-key] {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.cart-items__table.awtomic-ready tbody tr[data-key] {\n  opacity: 1;\n  visibility: visible;\n  transition: opacity 0.2s ease-in-out;\n}\n\n\n";
  (document.head || document.documentElement).appendChild(s);
})();


/**
 * Awtomic Theme Definitions v1.0.0
 * Theme detection and selector configurations for cart rollup
 * Load BEFORE awtomic-cart-extras.js
 */
(function () {
  var has = function (s) {
    return !!document.querySelector(s);
  };

  // Shared selectors for table-based themes (Horizon/Tinker)
  var TABLE_SELECTORS = {
    cartItemRow: 'tr[data-key]',
    title: '.cart-items__title',
    image: '.cart-items__media-image',
    imageContainer: '.cart-items__media-container',
    imageLink: '.cart-items__link',
    variants: '.cart-items__variants',
    variantsWrapper: '.cart-items__variants-wrapper',
    unitPriceWrapper: '.cart-items__unit-price-wrapper',
    price: '.cart-items__price',
    compareAtPrice: '.compare-at-price',
    qtyInput: 'input[type="number"]',
    qtyButtons: '.quantity-minus, .quantity-plus',
    removeButton: '.cart-items__remove',
  };

  // Shared selectors for Dawn and Dawn-derived themes
  var DAWN_SELECTORS = {
    cartItemRow: 'tr.cart-item, .cart-item',
    title: '.cart-item__name, a.cart-item__name',
    image: '.cart-item__image',
    imageContainer: '.cart-item__image-container',
    imageLink: 'a.cart-item__link',
    variants: '.product-option',
    variantsWrapper: '.cart-item__details',
    unitPriceWrapper: '.unit-price, .cart-item__totals',
    // Only the totals column carries a LINE total. `.product-option` is the
    // variants selector a few lines up (a variant row, a selling-plan name or
    // the per-unit price): leaving it here let the bundle total land on the
    // selling plan paragraph in the details cell, which precedes both totals
    // cells in document order.
    price: '.price--end',
    compareAtPrice: '.price--end',
    qtyInput: 'input.quantity__input',
    qtyButtons: '.quantity__button',
    removeButton: 'cart-remove-button a, .cart-remove-button a',
  };

  var DAWN_BUBBLE = {
    count: '.cart-count-bubble span[aria-hidden="true"]',
    visuallyHidden: '.cart-count-bubble .visually-hidden',
    container: '.cart-count-bubble',
    // Dawn's own screen-reader text is "N items", not the generic wording; keep
    // the theme's phrasing so the bubble does not read differently after rollup.
    hiddenLabel: function (n) {
      return n + ' items';
    },
  };

  // Shared cart bubble configs
  var BUBBLE = {
    count: '.cart-bubble__text-count',
    visuallyHidden: '.cart-bubble__text .visually-hidden',
    container: '.cart-bubble',
  };

  var BUBBLE_WIDE = {
    count:
      '[data-testid="cart-bubble"], .cart-count, [id*="cart-count"], .cart-count-bubble span[aria-hidden="true"], .cart-bubble__text-count',
    visuallyHidden: '.visually-hidden',
    container: '.cart-bubble, .cart-count-bubble',
  };

  window.awtomicThemeDefinitions = {
    themes: {
      tinker: {
        name: 'Tinker',
        detect: function () {
          return (
            has('dialog.cart-drawer__dialog') &&
            has('cart-items-component[data-drawer]')
          );
        },
        selectors: TABLE_SELECTORS,
        drawer: {
          selectors: 'dialog.cart-drawer__dialog[open], dialog[open]',
          visibilityCheck: function (el) {
            return el && el.hasAttribute('open');
          },
          itemsComponent: 'cart-items-component[data-drawer]',
          closestContainer: 'dialog.cart-drawer__dialog',
        },
        cartBubble: BUBBLE,
      },

      horizon: {
        name: 'Horizon',
        detect: function () {
          return has('tr[data-key]') && has('.cart-items__title');
        },
        selectors: TABLE_SELECTORS,
        drawer: {
          selectors: 'cart-drawer, [data-drawer], .cart-drawer, #cart-drawer',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.offsetParent ||
                el.hasAttribute('open') ||
                el.classList.contains('active') ||
                el.classList.contains('is-open'))
            );
          },
          itemsComponent: 'cart-items-component[data-drawer]',
          closestContainer: 'cart-drawer, .cart-drawer',
        },
        cartBubble: BUBBLE,
      },

      wonder: {
        name: 'Wonder',
        detect: function () {
          return has('.wt-cart__item') || has('.wt-cart__list');
        },
        selectors: {
          cartItemRow: 'li.wt-cart__item',
          title: '.wt-cart__item__name a',
          image: 'img.card__img',
          imageContainer: 'picture.wt-cart__item__thumb',
          imageLink: 'picture.wt-cart__item__thumb a.wt-cart__item__link',
          variants: '.options',
          variantsWrapper: '.wt-cart__item__data',
          unitPriceWrapper: '.wt-cart__item__price-wrapper',
          price: 'span.price.price--end',
          compareAtPrice: 's.cart-item__old-price',
          qtyInput: 'input.js-counter-quantity',
          qtyButtons: '.js-counter-button',
          removeButton: 'cart-remove-button a, a.wt-cart__item__remove',
        },
        drawer: {
          selectors:
            'cart-drawer-items.wt-cart__drawer__items, .wt-cart__drawer__body',
          visibilityCheck: function (el) {
            return el && el.offsetParent !== null;
          },
          itemsComponent: 'cart-drawer-items.wt-cart__drawer__items',
          closestContainer: '.wt-cart__drawer__body',
        },
        cartBubble: BUBBLE_WIDE,
      },

      dawn: {
        name: 'Dawn',
        detect: function () {
          var onCart = window.location.pathname.includes('/cart');
          return (
            has('quantity-popover') ||
            has('cart-remove-button') ||
            has('cart-items') ||
            (onCart &&
              (has('.cart-item__name') || has('.cart-item__image-container')))
          );
        },
        selectors: DAWN_SELECTORS,
        drawer: null,
        cartBubble: DAWN_BUBBLE,
      },

      // Dawn with the cart drawer turned on (Gatlinburg Winery).
      // Stock Dawn ships `drawer: null`, so on a store with the drawer enabled the
      // rollup never runs in the drawer, and on /cart it used to grab the drawer's
      // `table.cart-items` (Dawn renders the drawer before <main>) instead of the
      // page one. The page-side half of that is fixed in awtomic-cart-extras.js.
      // To widen this to every Dawn store with a drawer, drop the first `has(...)`.
      gatlinburg: {
        name: 'Dawn Drawer (Gatlinburg)',
        detect: function () {
          return (
            has(
              'link[href*="awtomic-theme-custom-gatlinburg"], script[src*="awtomic-theme-custom-gatlinburg"]',
            ) &&
            has('cart-drawer') &&
            has('cart-drawer-items')
          );
        },
        selectors: DAWN_SELECTORS,
        drawer: {
          selectors: 'cart-drawer',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.classList.contains('active') ||
                el.hasAttribute('open') ||
                el.classList.contains('is-open'))
            );
          },
          itemsComponent: 'cart-drawer-items',
          closestContainer: 'cart-drawer',
        },
        cartBubble: DAWN_BUBBLE,
      },

      supply: {
        name: 'Supply',
        detect: function () {
          return (
            (has('#CartDrawer.drawer, .drawer#CartDrawer') ||
              has('[data-products]') ||
              window.location.pathname.includes('/cart')) &&
            has('.cart__items, .cart__item')
          );
        },
        selectors: {
          cartItemRow: '.cart__item[data-key]',
          title: '.cart__item-name',
          image: '.cart__image img',
          imageContainer: '.cart__image',
          imageLink: '.cart__image a',
          variants: '.cart__item--variants',
          variantsWrapper: '.cart__item-details',
          unitPriceWrapper: '.cart__item-price-col',
          price: '.cart__price',
          compareAtPrice: '.cart__price--strikethrough',
          qtyInput: 'input.js-qty__num',
          qtyButtons: '.js-qty__adjust',
          removeButton: '.cart__remove a',
        },
        drawer: {
          selectors: '#CartDrawer.drawer--is-open, .drawer.drawer--is-open',
          visibilityCheck: function (el) {
            return el && el.classList.contains('drawer--is-open');
          },
          itemsComponent: '.cart__items',
          closestContainer: '#CartDrawer, .drawer',
        },
        cartBubble: BUBBLE_WIDE,
      },

      rebuy: {
        name: 'Rebuy',
        detect: function () {
          return has('#rebuy-cart, .rebuy-cart');
        },
        selectors: {
          cartItemRow: 'li.rebuy-cart__flyout-item',
          title: '.rebuy-cart__flyout-item-product-title',
          image: '.rebuy-cart__flyout-item-media img',
          imageContainer: '.rebuy-cart__flyout-item-media',
          imageLink: '.rebuy-cart__flyout-item-media a',
          variants: '.rebuy-cart__flyout-item-discount-message',
          variantsWrapper: '.rebuy-cart__flyout-item-info',
          unitPriceWrapper: '.rebuy-cart__flyout-item-price',
          price: '.rebuy-money.sale span:not(.sr-only)',
          compareAtPrice: '.rebuy-money.compare-at span:not(.sr-only)',
          qtyInput: '.rebuy-cart__flyout-item-quantity-widget-label',
          qtyButtons: '.rebuy-cart__flyout-item-quantity-widget-button',
          removeButton: '.rebuy-cart__flyout-item-remove',
        },
        drawer: {
          selectors:
            '#rebuy-cart.is-visible, #rebuy-cart[aria-hidden="false"], .rebuy-cart.is-visible',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.classList.contains('is-visible') ||
                el.getAttribute('aria-hidden') === 'false')
            );
          },
          itemsComponent: 'ul[data-smartcart-items]',
          closestContainer: '#rebuy-cart, .rebuy-cart',
        },
        cartBubble: BUBBLE_WIDE,
      },

      debut: {
        name: 'Debut',
        detect: function () {
          return (
            has('[data-section-type="cart-template"]') &&
            has('.list-view-item__title')
          );
        },
        selectors: {
          cartItemRow: 'tr.cart__row',
          title: '.list-view-item__title a',
          image: 'img.cart__image',
          imageContainer: '.cart__image-wrapper',
          imageLink: '.cart__image-wrapper a',
          variants: '.cart__meta-text',
          variantsWrapper: '.cart__meta',
          unitPriceWrapper: '.cart__price-wrapper',
          price:
            'td.text-right.small--hide > div:not(.cart-item__original-price):not(.cart-item__discount)',
          compareAtPrice: '.cart-item__original-price',
          qtyInput: 'input.cart__qty-input',
          qtyButtons: '.cart__qty-adjust',
          removeButton: 'a.cart__remove',
        },
        drawer: null,
        cartBubble: {
          count: '#CartCount > span:first-child',
          visuallyHidden: '#CartCount .icon__fallback-text',
          container: '#CartCount',
        },
      },

      bls: {
        name: 'BLS',
        detect: function () {
          return has('.bls-minicart-wrapper') && has('.bls-items');
        },
        selectors: {
          cartItemRow: 'div.cart-item',
          title: '.bls-minicart-product-name a',
          image: '.bls-minicart-product__image img',
          imageContainer: '.bls-minicart-product__image',
          imageLink: '.bls-minicart-product__image a',
          variants: '.bls-minicart-item-variant',
          variantsWrapper: '.bls-minicart-product-info',
          unitPriceWrapper: '.bls-minicart-item-prices',
          price: '.bls-minicart-item-price',
          compareAtPrice: '.bls-minicart-item-original-price',
          qtyInput: 'input.bls-quantity-input',
          qtyButtons: '.quantity__button',
          removeButton:
            'mini-cart-remove-button a, .bls-minicart-item-remove a',
        },
        drawer: {
          selectors: '.bls-minicart-wrapper',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.offsetParent !== null ||
                el.classList.contains('active') ||
                el.classList.contains('is-open') ||
                el.classList.contains('open'))
            );
          },
          itemsComponent: '.bls-items',
          closestContainer: '.bls-minicart-wrapper',
        },
        cartBubble: BUBBLE_WIDE,
      },

      eVoiCustom: {
        name: 'eVoi Custom',
        detect: function () {
          return (
            has('input.quantity__input') &&
            (has('.cart__row.cart__item') ||
              has('#CartDrawer-CartItems') ||
              has('.drawer__contents-items') ||
              has('.drawer__inner[role="dialog"]'))
          );
        },
        selectors: {
          cartItemRow: '.cart__row.cart__item',
          title: '.cart-item__name.cart__product-title',
          image: 'img.cart__image',
          imageContainer: '.cart__image-box',
          imageLink: '.cart__image-wrapper a',
          variants: '.product-option',
          variantsWrapper: '.cart__product-information',
          unitPriceWrapper: '.unit-price, .cart__final-price',
          price: '.cart__final-price > div',
          compareAtPrice: 's.price--end',
          qtyInput: 'input.quantity__input',
          qtyButtons: '.quantity__button',
          removeButton: 'cart-remove-button a',
        },
        drawer: {
          selectors: '.drawer__inner[role="dialog"]',
          visibilityCheck: function (el) {
            return el && el.offsetParent !== null;
          },
          itemsComponent: '#CartDrawer-CartItems, .drawer__contents-items',
          closestContainer: '.drawer__inner',
        },
        cartBubble: BUBBLE_WIDE,
      },

      stretch: {
        name: 'Stretch',
        detect: function () {
          return (
            (has('line-item') || has('.line-item')) &&
            (has('table.order-summary') || has('cart-drawer'))
          );
        },
        selectors: {
          cartItemRow: 'tr, line-item',
          title: 'a.subheading[href*="/products/"]',
          image: 'img',
          imageContainer: '.line-item__media',
          imageLink: 'a.line-item__media',
          variants: 'ul[role="list"]',
          variantsWrapper: '.line-item__info',
          unitPriceWrapper: '.v-stack.justify-items-end',
          price: '.line-item__line-price',
          compareAtPrice: '.compare-at-price',
          qtyInput: 'input.quantity-selector__input',
          qtyButtons: '.quantity-selector__button',
          removeButton: '.line-item__remove-button',
        },
        drawer: {
          selectors: 'cart-drawer',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.hasAttribute('open') ||
                (el.offsetParent !== null && el.style.display !== 'none'))
            );
          },
          itemsComponent: 'line-item',
          closestContainer: 'cart-drawer',
        },
        cartBubble: {
          count: '.h7',
          visuallyHidden: '.sr-only',
          container: 'cart-drawer',
        },
      },

      generic: {
        name: 'Generic',
        detect: function () {
          return true;
        },
        selectors: {
          cartItemRow: 'tr[data-key], li[data-key], div[data-key]',
          title: 'a[href*="/products/"]',
          image: 'img[src*="cdn.shopify.com"]',
          imageContainer: '.image-container, .media-container',
          imageLink: 'a[href*="/products/"]',
          variants: 'dl, .variant',
          variantsWrapper: '.variants-wrapper, .product-options',
          unitPriceWrapper: '.price-wrapper, .unit-price',
          price: '.price, .money',
          compareAtPrice: '.compare-at-price, .was-price',
          qtyInput: 'input[type="number"]',
          qtyButtons: 'button[name*="plus"], button[name*="minus"]',
          removeButton: 'button[class*="remove"], a[class*="remove"]',
        },
        drawer: {
          selectors:
            'cart-drawer, [data-drawer], .cart-drawer, #cart-drawer, dialog[open]',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.offsetParent ||
                el.hasAttribute('open') ||
                el.classList.contains('active') ||
                el.classList.contains('is-open'))
            );
          },
          itemsComponent: 'cart-items-component[data-drawer]',
          closestContainer: 'cart-drawer, .cart-drawer, dialog',
        },
        cartBubble: BUBBLE_WIDE,
      },
    },

    // Detection priority (specific first, generic last as fallback).
    // Merchant-specific entries go first: the generic ones are loose enough to
    // swallow them (eVoiCustom matches any Dawn store with a cart drawer,
    // because Dawn's drawer carries #CartDrawer-CartItems).
    detectionOrder: [
      'gatlinburg',
      'tinker',
      'horizon',
      'stretch',
      'wonder',
      'eVoiCustom',
      'dawn',
      'supply',
      'debut',
      'bls',
      'generic',
    ],
  };
})();

/**
 * Awtomic Cart Rollup v1.2.1
 * Consolidates bundle items in cart UI
 */
(function () {
  'use strict';

  const config = window.awtomicCartExtrasConfig || {};
  const DEBUG = config.debugMode || false;
  const debug = (...args) => DEBUG && console.log('[Awtomic]', ...args);

  const defs = window.awtomicThemeDefinitions || {
    themes: {},
    detectionOrder: [],
  };
  if (!window.awtomicThemeDefinitions) {
    console.warn(
      '[Awtomic] Theme definitions not found. Include awtomic-theme-definitions.js.',
    );
  }

  const detectTheme = () => {
    if (config.theme) {
      return config.theme;
    }
    for (const key of defs.detectionOrder) {
      if (defs.themes[key]?.detect?.()) {
        debug(`Theme: ${defs.themes[key].name}`);
        return defs.themes[key];
      }
    }
    return (
      defs.themes.generic || {
        name: 'Fallback',
        detect: () => true,
        selectors: {},
        drawer: null,
        cartBubble: null,
      }
    );
  };

  let THEME = detectTheme();
  const THEME_KEY_MAP = { 'evoi custom': 'evoi' };
  const norm = (n) => {
    const lower = (n || THEME.name).toLowerCase();
    return THEME_KEY_MAP[lower] || lower;
  };

  const cfg = {
    containerSelector: {
      rebuy: 'ul[data-smartcart-items]',
      supply: '.cart__items',
      wonder: 'ul.wt-cart__list',
      bls: '.bls-items',
      evoi: '.cart__row.cart__item',
      stretch: 'line-item, tr',
      default: 'tbody',
    },
    bundleItemSelector: {
      rebuy: (id) => `li[data-bundle-id="${id}"]`,
      supply: (id) => `.cart__item[data-bundle-id="${id}"]`,
      evoi: (id) => `.cart__row.cart__item[data-bundle-id="${id}"]`,
      stretch: (id) =>
        `line-item[data-bundle-id="${id}"], tr[data-bundle-id="${id}"]`,
      default: (id) => `[data-bundle-id="${id}"]`,
    },
    cleanupSelector: {
      rebuy: 'li.awtomic-processed, li[data-awtomic-bundle]',
      bls: '.cart-item[data-awtomic-bundle]',
      supply: '.cart__item[data-awtomic-bundle]',
      wonder: 'li.awtomic-processed, li[data-awtomic-bundle]',
      evoi: '.cart__row[data-awtomic-bundle]',
      stretch: 'line-item[data-awtomic-bundle], tr[data-awtomic-bundle]',
      default: '[data-awtomic-bundle]',
    },
    findContainer: {
      rebuy: (ctx) => {
        const el = ctx.container.querySelector(
          'ul[data-smartcart-items], .rebuy-cart__flyout-items',
        );
        return { items: el, root: el };
      },
      bls: (ctx) => {
        const el = (
          ctx.type === 'drawer' ? ctx.container : document
        ).querySelector('.bls-items');
        return { items: el, root: el };
      },
      supply: (ctx) => {
        let el;
        if (ctx.type === 'drawer') {
          el = ctx.container.querySelector('.cart__items');
        } else {
          el =
            document.querySelector('[data-products]') ||
            document.querySelector('.cart__items');
        }
        return { items: el, root: el };
      },
      wonder: (ctx) => {
        const el = (
          ctx.type === 'drawer' ? ctx.container : document
        ).querySelector('ul.wt-cart__list');
        return { items: el, root: el };
      },
      evoi: (ctx) => {
        const root = ctx.type === 'drawer' ? ctx.container : document;
        let el = root.querySelector(
          '#CartDrawer-CartItems, .drawer__contents-items, .cart__items, .cart-items',
        );
        if (!el) {
          const first = root.querySelector('.cart__row.cart__item');
          el =
            first?.closest(
              '.cart-form, .cart-wrapper, .cart-content, div[data-cart], form',
            ) || first?.parentElement;
        }
        return { items: el, root: el };
      },
      stretch: (ctx) => {
        const root = ctx.type === 'drawer' ? ctx.container : document;
        let el =
          root.querySelector('table.order-summary') ||
          root.querySelector('form[action*="/cart"] table');
        if (ctx.type === 'drawer') {
          for (const container of root.querySelectorAll('[class*="v-stack"]')) {
            if (
              container.querySelectorAll(
                ':scope > line-item:not([data-bundle-id])',
              ).length > 0
            ) {
              el = container;
              break;
            }
          }
        }
        return { items: el, root: el };
      },
      default: (ctx) => {
        const root = ctx.type === 'drawer' ? ctx.container : document;
        const TABLES =
          '.cart-items__table, table.cart-items, form[action*="/cart"] table';
        // On the cart page the table has to come from the page itself. Themes
        // that ship a cart drawer (Dawn & co.) render the drawer markup before
        // <main>, so the first matching table in the document is the drawer's
        // (hidden) one: rolling that up leaves /cart untouched. Skip any table
        // that lives inside a drawer, and only then fall back to the first one.
        const inDrawer = (el) =>
          !!el.closest(
            'cart-drawer, cart-drawer-items, .cart-drawer, #CartDrawer, [id*="cart-drawer"], [class*="cart-drawer"], dialog',
          );
        const el =
          ctx.type === 'drawer'
            ? root.querySelector(TABLES)
            : Array.from(document.querySelectorAll(TABLES)).find(
                (t) => !inDrawer(t),
              ) || document.querySelector(TABLES);
        return { items: el, root: el?.querySelector('tbody') };
      },
    },
    keyExtractors: [
      (row) => row.dataset.key || null,
      (row) =>
        row.querySelector('input[data-line-key]')?.dataset.lineKey || null,
      (row) => row.querySelector('input[data-key]')?.dataset.key || null,
      (row, data) => {
        const cls = Array.from(row.classList).find((c) =>
          c.startsWith('property-_bundleuid:'),
        );
        if (cls) {
          const uid = cls.split(':')[1];
          return data?.items?.find(
            (it) => it.properties?.['_bundleUid']?.replace(/-/g, '') === uid,
          )?.key;
        }
        const prod = Array.from(row.classList).find(
          (c) => c.startsWith('product-') && !c.startsWith('product-id-'),
        );
        return (
          prod &&
          data?.items?.find((it) => it.handle === prod.replace('product-', ''))
            ?.key
        );
      },
      (row) => {
        const key = row
          .querySelector('input.cart__qty-input')
          ?.id?.replace('updates_', '');
        return key && key !== 'undefined' ? key : null;
      },
      (row) => {
        // BLS only: `replace` on an id that does not carry the prefix returns the
        // id itself, which is truthy, so this used to swallow every other theme's
        // row (Dawn's `CartItem-1`) before the id-index extractor below could run.
        if (!row.id?.startsWith('bls-minicart-product-')) {
          return null;
        }
        const key = row.id.replace('bls-minicart-product-', '');
        return key && key !== 'undefined' ? key : null;
      },
      (row, data) => {
        const match = row.id?.match(/Cart(?:Drawer-)?Item-(\d+)/);
        return (match && data?.items?.[parseInt(match[1]) - 1]?.key) || null;
      },
    ],
  };

  const getConfig = (theme) => {
    const n = norm(theme);
    return {
      containerSelector:
        cfg.containerSelector[n] || cfg.containerSelector.default,
      bundleItemSelector:
        cfg.bundleItemSelector[n] || cfg.bundleItemSelector.default,
      cleanupSelector: cfg.cleanupSelector[n] || cfg.cleanupSelector.default,
      findContainer: cfg.findContainer[n] || cfg.findContainer.default,
      keyExtractors: cfg.keyExtractors,
    };
  };

  const injectCSS = () => {
    const anti = document.createElement('style');
    anti.id = 'awtomic-anti-flicker';
    anti.textContent = `body:not(.awtomic-ready) .cart__items:not(.awtomic-ready),
      body:not(.awtomic-ready) [data-products]:not(.awtomic-ready),
      body:not(.awtomic-ready) .rebuy-cart__flyout-items:not(.awtomic-ready),
      body:not(.awtomic-ready) .cart-items__table:not(.awtomic-ready),
      body:not(.awtomic-ready) cart-items-component[data-drawer]:not(.awtomic-ready),
      body:not(.awtomic-ready) .wt-cart__list:not(.awtomic-ready),
      body:not(.awtomic-ready) .bls-items:not(.awtomic-ready),
      body:not(.awtomic-ready) [data-section-type="cart-template"] table tbody:not(.awtomic-ready) {
        visibility: hidden !important; opacity: 0 !important; }`;
    document.head.appendChild(anti);
    const styles = document.createElement('style');
    styles.id = 'awtomic-styles';
    styles.textContent = `line-item[data-awtomic-hidden], tr[data-awtomic-hidden] { display: none !important; }
      tbody.awtomic-original { display: none !important; }
      tbody.awtomic-processed { display: table-row-group !important; }`;
    document.head.appendChild(styles);
  };

  const removeAntiFlicker = () => {
    document.body.classList.add('awtomic-ready');
    setTimeout(
      () => document.getElementById('awtomic-anti-flicker')?.remove(),
      1000,
    );
  };

  injectCSS();

  let isProcessing = false,
    lastTime = 0;
  const lastData = {};

  const fetchCart = async () => {
    const res = await fetch('/cart.js');
    return res.ok ? res.json() : null;
  };

  const groupBundles = (data) => {
    const groups = {};
    for (const item of data?.items || []) {
      const bid = item.properties?._bundleUid;
      if (bid) {
        if (!groups[bid]) {
          groups[bid] = { items: [], properties: item.properties };
        }
        groups[bid].items.push(item);
      }
    }
    return groups;
  };

  const extractKey = (row, data, extractors) => {
    for (const ex of extractors) {
      const key = ex(row, data);
      if (key) {
        return key;
      }
    }
    return null;
  };

  // ---------------------------------------------------------------------------
  // Bundle row rendering
  //
  // Everything from here down to updateCartBubble was ported from the hand-made
  // `v1.1.1 OPTIMIZED` build that has been running in merchant themes (Gatlinburg,
  // Orenda, Skipstone, Double Good, New5Hour, Vieniest) but never existed in this
  // repo. Without it the rollup collapses the bundle but the surviving row keeps
  // the first bottle's image, price and quantity stepper, and the header bubble
  // counts line items instead of bundles.
  // ---------------------------------------------------------------------------

  const formatPrice = (cents) => {
    if (typeof window.Shopify?.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents);
      } catch {
        /* falls through to the plain format below */
      }
    }
    return `$${(cents / 100).toFixed(2)}`;
  };

  const updateElement = (el, props) => el && Object.assign(el, props);
  const setStyles = (el, styles) => el && Object.assign(el.style, styles);
  const queryInRow = (row, name, selectors) =>
    row.querySelector((selectors || THEME.selectors)[name]);

  // The cart line item only carries the bottle products; the bundle's own title,
  // image and variant live on the bundle product, which has to be fetched. Cache
  // by handle+variant and dedupe in-flight requests: process() runs once per
  // context (page, drawer, rebuy) and every one of them wants the same product.
  const productCache = new Map();
  const productInflight = new Map();

  const fetchBundleProductData = async (bundleHandle, variantId) => {
    const cacheKey = `${bundleHandle}:${variantId}`;
    if (productCache.has(cacheKey)) {
      return productCache.get(cacheKey);
    }
    if (productInflight.has(cacheKey)) {
      return productInflight.get(cacheKey);
    }

    const promise = (async () => {
      try {
        const res = await fetch(`/products/${bundleHandle}.js`);
        if (!res.ok) {
          throw new Error(`Product fetch failed: ${res.status}`);
        }
        const product = await res.json();
        const result = {
          product,
          variant: product.variants.find(
            (v) => v.id.toString() === String(variantId).split('/').pop(),
          ),
        };
        productCache.set(cacheKey, result);
        return result;
      } catch (e) {
        debug('Bundle product fetch failed', bundleHandle, e);
        return null;
      } finally {
        productInflight.delete(cacheKey);
      }
    })();

    productInflight.set(cacheKey, promise);
    return promise;
  };

  // One line per bottle inside the collapsed row.
  const createBundleSubitem = (item) => {
    const subitem = document.createElement('div');
    subitem.className = 'bundle-subitem';
    subitem.style.cssText =
      'display: flex; align-items: flex-start; margin-bottom: 8px;';

    if (item.image) {
      const img = Object.assign(document.createElement('img'), {
        src: item.image,
        alt: item.product_title,
      });
      img.style.cssText =
        'width: 30px; height: 30px; margin-right: 8px; object-fit: cover; flex-shrink: 0;';
      subitem.appendChild(img);
    }

    const details = document.createElement('div');
    details.className = 'bundle-subitem-details';
    details.style.cssText = 'flex: 1; font-size: 0.875em; line-height: 1.4;';

    const titleDiv = document.createElement('div');
    titleDiv.style.cssText = 'font-weight: 500;';
    titleDiv.textContent = item.product_title;
    details.appendChild(titleDiv);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      const variantDiv = document.createElement('div');
      variantDiv.style.cssText = 'color: #6b7280; font-size: 0.9em;';
      variantDiv.textContent = item.variant_title;
      details.appendChild(variantDiv);
    }

    const qtyDiv = document.createElement('div');
    qtyDiv.style.cssText = 'color: #6b7280; font-size: 0.9em; margin-top: 2px;';
    qtyDiv.textContent = `Qty: ${item.quantity}`;
    details.appendChild(qtyDiv);

    subitem.appendChild(details);
    return subitem;
  };

  // BOGO: the free half of a buy-one-get-one is a second bundle whose line items
  // are priced at 0. Summing its lines would print the wrong number on both rows,
  // so a bogo row keeps whatever price the theme already rendered.
  const isBogoRow = (bundleRow) =>
    bundleRow.dataset.bogoFreeBundle === 'true' ||
    bundleRow.dataset.bogoBaseBundle === 'true';

  const tagBogo = (bundleRow, group) => {
    if (
      group.items.some((i) => i.properties?.['_bogo-free-bundle'] === 'true')
    ) {
      bundleRow.dataset.bogoFreeBundle = 'true';
    }
    if (
      group.items.some((i) => i.properties?.['_bogo-base-bundle'] === 'true')
    ) {
      bundleRow.dataset.bogoBaseBundle = 'true';
    }
    if (group.properties._bogoGroupId) {
      bundleRow.dataset.bogoGroupId = group.properties._bogoGroupId;
    }
  };

  const updateBundlePrices = (bundleRow, items, selectors) => {
    if (isBogoRow(bundleRow)) {
      return;
    }
    const sel = selectors || THEME.selectors;

    // Some themes apply a cart-wide discount client side (window.theme.Discount).
    const pct =
      (typeof window.theme?.Discount?.getDiscountPercent === 'function' &&
        window.theme.Discount.getDiscountPercent()) ||
      0;
    const applyPct = (cents) => {
      if (!pct) {
        return cents;
      }
      return typeof window.theme?.Discount?.applyDiscount === 'function'
        ? window.theme.Discount.applyDiscount(cents, pct)
        : Math.round(cents * (1 - pct / 100));
    };

    // What the row has to SHOW is what the customer pays: sum final_line_price,
    // which already carries any line level discount (club %, automatic discount).
    // original_line_price is the compare-at, never the total (v1.1.0 behaviour;
    // v1.2.0 summed the pre-discount price and showed it as the total).
    const original = items.reduce((sum, i) => sum + i.original_line_price, 0);
    const final = applyPct(
      items.reduce((sum, i) => sum + i.final_line_price, 0),
    );
    const compareAt = original > final ? original : 0;

    const wrapper = queryInRow(bundleRow, 'unitPriceWrapper', sel);
    if (wrapper) {
      updateElement(
        wrapper.querySelector(
          'span:not(.visually-hidden):not(.compare-at-price)',
        ),
        { textContent: formatPrice(final) },
      );
      if (compareAt > final) {
        updateElement(wrapper.querySelector(sel.compareAtPrice), {
          textContent: formatPrice(compareAt),
        });
      }
    }

    if (norm() === 'rebuy') {
      const wrap = bundleRow.querySelector('.rebuy-cart__flyout-item-price');
      if (wrap) {
        wrap.innerHTML =
          compareAt > final
            ? `<span class="rebuy-money sale"><span class="sr-only">Sale price</span><span>${formatPrice(final)}</span></span><span class="rebuy-money compare-at"><span class="sr-only">Compare At Price</span><span>${formatPrice(compareAt)}</span></span>`
            : `<span class="rebuy-money"><span class="sr-only">Item Price</span><span>${formatPrice(final)}</span></span>`;
      }
      const badge = bundleRow.querySelector(
        '.rebuy-cart__flyout-item-discount-message',
      );
      if (pct) {
        const text = `Discount Applied ${pct}%`;
        if (badge) {
          badge.textContent = text;
        } else {
          bundleRow
            .querySelector('.rebuy-cart__flyout-item-product-title')
            ?.insertAdjacentHTML(
              'afterend',
              `<div class="rebuy-cart__flyout-item-discount-message">${text}</div>`,
            );
        }
      } else {
        badge?.remove();
      }
      return;
    }

    // The bundle row is a clone of the FIRST bottle's row, so every price node in
    // it still reads that bottle's total until it is overwritten. Dawn renders the
    // totals column twice per row (one cell for phones, one for desktop, each
    // hidden by a media query), so a single querySelector reaches only the phone
    // one and desktop keeps showing the first bottle's price: write every match.
    // The fallback stays a single node on purpose: it matches whole cells on
    // themes we have no selectors for, and writing all of them would clobber
    // markup instead of a price.
    const priceEls = bundleRow.querySelectorAll(sel.price);
    const targets = priceEls.length
      ? Array.from(priceEls)
      : [
          bundleRow.querySelector(
            'td.total strong, td.total, [class*="total"] strong, [class*="price"] strong',
          ),
        ].filter(Boolean);
    targets.forEach((el) => {
      // In the discounted markup the same selector also matches the struck-out
      // regular price sitting next to the total; that node is the compare-at.
      if (el.closest('s, del, .cart-item__old-price, .compare-at-price')) {
        if (compareAt > final) {
          updateElement(el, { textContent: formatPrice(compareAt) });
        }
        return;
      }
      updateElement(el, { textContent: formatPrice(final) });
    });
  };

  // A bundle is bought and removed as a unit: the stepper has to read 1 and the
  // +/- buttons have to go, or the customer can desync the bundle's line items.
  const disableBundleQuantityControls = (bundleRow, theme, selectors) => {
    const sel = selectors || THEME.selectors;
    const qty = queryInRow(bundleRow, 'qtyInput', sel);

    if (norm(theme) === 'rebuy') {
      const text = Array.from(qty?.childNodes || []).find(
        (n) => n.nodeType === Node.TEXT_NODE,
      );
      if (text) {
        text.textContent = ' 1 ';
      }
    } else {
      updateElement(qty, { value: '1', readOnly: true, disabled: true });
    }

    bundleRow.querySelectorAll(sel.qtyButtons).forEach((btn) =>
      setStyles(btn, {
        visibility: 'hidden',
        opacity: '0',
        pointerEvents: 'none',
      }),
    );
  };

  // The cloned remove button still points at the first bottle's line, so removing
  // the bundle would leave the other three behind: zero every line of the group.
  const setupRemoveButton = (bundleRow, bid, selectors, theme) => {
    const sel = selectors || THEME.selectors;
    let buttons = Array.from(bundleRow.querySelectorAll(sel.removeButton));
    if (!buttons.length) {
      buttons = Array.from(bundleRow.querySelectorAll('button')).filter((b) => {
        const t = b.textContent.trim();
        return (
          t === '×' ||
          t === '✕' ||
          t === 'x' ||
          t.toLowerCase().includes('remove')
        );
      });
    }
    if (!buttons.length) {
      return;
    }

    // Dawn's <cart-remove-button> is a custom element wired to the line index it
    // was cloned from; flatten it to a plain span so only our handler runs.
    bundleRow
      .querySelectorAll('cart-remove-button, mini-cart-remove-button')
      .forEach((el) => {
        const plain = document.createElement('span');
        plain.className = el.className;
        if (el.id) {
          plain.id = el.id;
        }
        while (el.firstChild) {
          plain.appendChild(el.firstChild);
        }
        el.parentNode.replaceChild(plain, el);
      });

    const onRemove = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      setStyles(bundleRow, { opacity: '0.6', pointerEvents: 'none' });
      try {
        const data = await fetchCart();
        const updates = {};
        for (const item of data?.items || []) {
          if (item.properties?._bundleUid === bid) {
            updates[item.key] = 0;
          }
        }
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });
        if (!res.ok) {
          throw new Error(`Cart update failed: ${res.status}`);
        }
        bundleRow.remove();
        const fresh = await fetchCart();
        if (fresh) {
          updateCartBubble(fresh);
          for (const key of Object.keys(lastData)) {
            delete lastData[key];
          }
        }
      } catch (err) {
        console.error('[Awtomic] Remove failed:', err);
        setStyles(bundleRow, { opacity: '', pointerEvents: '' });
      }
    };

    buttons.forEach((button) => {
      const wrapper = document.createElement('div');
      setStyles(
        wrapper,
        norm(theme) === 'rebuy'
          ? {
              display: 'inline-block',
              cursor: 'pointer',
              position: 'absolute',
              top: '0',
              right: '0',
              width: '20px',
              height: '20px',
            }
          : { display: 'inline-block', cursor: 'pointer' },
      );
      button.parentNode.insertBefore(wrapper, button);
      wrapper.appendChild(button);
      button.href = '#';
      setStyles(button, { pointerEvents: 'none' });
      wrapper.addEventListener('click', onRemove);
    });
  };

  const updateBundleImage = (bundleRow, product, selectors) => {
    const sel = selectors || THEME.selectors;
    const container = queryInRow(bundleRow, 'imageContainer', sel);
    if (!container) {
      return;
    }
    const src = product?.featured_image || product?.images?.[0]?.src;
    if (!src) {
      container.style.visibility = 'hidden';
      return;
    }
    const img = container.querySelector('img');
    if (img) {
      img.src = src;
      img.alt = product.title || '';
      img.removeAttribute('srcset');
    }
    const link = container.querySelector('a');
    if (link && product.handle) {
      link.href = `/products/${product.handle}`;
    }
  };

  const addVariantAndSubscription = (wrapper, variant, allocation) => {
    if (!wrapper || !variant) {
      return;
    }
    const lists = Array.from(wrapper.querySelectorAll('ul.list-unstyled'));

    if (variant.title && variant.title !== 'Default Title') {
      const div = Object.assign(document.createElement('div'), {
        className: 'cart-items__variant',
        textContent: variant.title,
      });
      setStyles(div, { margin: '5px 0', display: 'block' });
      wrapper.insertBefore(div, wrapper.firstChild);
    }

    const plan = allocation?.selling_plan;
    if (plan && !lists.some((ul) => ul.textContent.includes(plan.name))) {
      const list = Object.assign(document.createElement('ul'), {
        className: 'list-unstyled',
      });
      const li = document.createElement('li');
      li.textContent = plan.name;
      list.appendChild(li);
      list.setAttribute('role', 'list');
      const anchor = lists[lists.length - 1];
      (anchor || wrapper).parentNode.insertBefore(
        list,
        anchor?.nextSibling || null,
      );
    }
  };

  // The header bubble counts line items, so a 4-bottle bundle reads 4 while the
  // cart shows one row. Count each bundle once plus the standalone quantities.
  const updateCartBubble = (data) => {
    const bubble = THEME.cartBubble;
    if (!bubble || !data) {
      return;
    }
    const groups = groupBundles(data);
    const bundled = new Set(
      Object.values(groups).flatMap((g) => g.items.map((i) => i.key)),
    );
    const total =
      Object.keys(groups).length +
      data.items
        .filter((i) => !bundled.has(i.key))
        .reduce((sum, i) => sum + (i.quantity || 0), 0);

    document.querySelectorAll(bubble.count).forEach((el) => {
      el.textContent = total;
    });
    document.querySelectorAll(bubble.container).forEach((container) => {
      container.querySelectorAll(bubble.visuallyHidden).forEach((el) => {
        el.textContent = bubble.hiddenLabel
          ? bubble.hiddenLabel(total)
          : `Total items in cart: ${total}`;
      });
      container.classList.add('awtomic-ready');
    });
  };

  const findMatches = (data, container, selectors, theme) => {
    const matches = [];
    for (const row of container.querySelectorAll(selectors.cartItemRow)) {
      const key = extractKey(row, data, getConfig(theme).keyExtractors);
      if (
        key &&
        data?.items?.find((i) => i.key === key) &&
        !matches.some((m) => m.cartItem.key === key)
      ) {
        matches.push({ row, cartItem: data.items.find((i) => i.key === key) });
      }
    }
    return matches;
  };

  const createBundles = async (
    groups,
    matches,
    theme,
    selectors,
    containers,
  ) => {
    // Every context wants the same bundle products: resolve them all at once so
    // the rows below read them straight from the cache.
    await Promise.all(
      Object.values(groups)
        .filter((g) => g.properties._bundleHandle && g.properties._variantId)
        .map((g) =>
          fetchBundleProductData(
            g.properties._bundleHandle,
            g.properties._variantId,
          ),
        ),
    );

    for (const [bid, group] of Object.entries(groups)) {
      const cfg = getConfig(theme);
      if (containers?.root?.querySelector(cfg.bundleItemSelector(bid))) {
        continue;
      }

      const first = matches.find((m) => m.cartItem.key === group.items[0].key);
      if (!first) {
        continue;
      }

      const cached =
        productCache.get(
          `${group.properties._bundleHandle}:${group.properties._variantId}`,
        ) || null;
      const product = cached?.product || null;
      const variant = cached?.variant || null;

      const isDirect = norm(theme) === 'rebuy';
      const bundle = isDirect ? first.row : first.row.cloneNode(true);
      Object.assign(bundle.dataset, {
        bundleId: bid,
        bundleHandle: group.properties._bundleHandle,
        awtomicBundle: 'true',
        key: `bundle-${bid}`,
      });
      tagBogo(bundle, group);

      const variantsWrapper = bundle.querySelector(selectors.variantsWrapper);
      const variants = bundle.querySelector(selectors.variants);
      if (variants && norm(theme) !== 'evoi') {
        variants.remove();
      }

      bundle.querySelectorAll('ul.list-unstyled').forEach((el) => el.remove());
      bundle
        .querySelectorAll('ul[role="list"]:not(.unstyled-list)')
        .forEach((el) => el.remove());

      if (norm(theme) === 'rebuy') {
        const props = bundle.querySelector(
          '.rebuy-cart__flyout-item-properties',
        );
        if (props) {
          props.style.display = 'none';
        }
      }

      // The bundle product's own title beats the properties the widget wrote:
      // `_bundleName` is a handle-ish slug ("gatlinbear-cub").
      const titleText =
        product?.title ||
        group.properties.bundle ||
        (group.properties._bundleName
          ? group.properties._bundleName
              .split('-')
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
              .join(' ')
          : 'Bundle');
      const titleHref = product
        ? `/products/${product.handle}${variant ? `?variant=${variant.id}` : ''}`
        : group.properties._bundleHandle
          ? `/products/${group.properties._bundleHandle}`
          : null;

      // Dawn wraps the thumbnail in its own <a href="/products/...">, which also
      // matches the title selector: take the first link that is not an image.
      const titleLinks = bundle.querySelectorAll(selectors.title);
      let title = null;
      for (const link of titleLinks) {
        if (!link.querySelector('img')) {
          title = link;
          break;
        }
      }
      if (!title && titleLinks.length) {
        title = titleLinks[0];
      }
      if (title) {
        title.textContent = titleText;
        if (titleHref) {
          title.href = titleHref;
        }
        // Any other product link left in the same cell still points at the first
        // bottle; drop it, or hide it when it is the (already re-pointed) image.
        const cell = title.closest('td, div, li') || title.parentElement;
        cell?.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          if (link === title) {
            return;
          }
          if (link.querySelector('img')) {
            link
              .querySelectorAll('img')
              .forEach((img) => (img.style.visibility = 'hidden'));
          } else {
            link.remove();
          }
        });
      }

      updateBundleImage(bundle, product, selectors);

      // With no variants wrapper the subitems have nowhere to live that survives
      // the theme's layout: give the title its own inline block and hang them off it.
      let titleWrapper = null;
      if (title && !variantsWrapper) {
        titleWrapper = document.createElement('div');
        titleWrapper.style.cssText =
          'display: inline-block; vertical-align: top;';
        title.parentNode.insertBefore(titleWrapper, title);
        titleWrapper.appendChild(title);
      }

      if (variantsWrapper && variant) {
        addVariantAndSubscription(
          variantsWrapper,
          variant,
          group.items[0].selling_plan_allocation,
        );
      }

      const subitemsTarget =
        variantsWrapper ||
        titleWrapper ||
        (title && (title.closest('td, div, li') || title.parentElement));
      if (subitemsTarget) {
        const list = document.createElement('div');
        list.className = 'bundle-subitems';
        list.style.marginTop = '15px';
        group.items.forEach((item) =>
          list.appendChild(createBundleSubitem(item)),
        );
        subitemsTarget.appendChild(list);
      }

      updateBundlePrices(bundle, group.items, selectors);
      disableBundleQuantityControls(bundle, theme, selectors);
      setupRemoveButton(bundle, bid, selectors, theme);

      if (!isDirect) {
        // In place of the first bottle, not at the end of the table: a cart with
        // a bundle plus loose items has to keep its order.
        const target =
          containers?.root ||
          first.row.closest(cfg.containerSelector) ||
          first.row.parentElement;
        if (first.row.parentNode) {
          first.row.parentNode.insertBefore(bundle, first.row);
        } else if (target) {
          target.appendChild(bundle);
        }
      }

      group.items.forEach((item) => {
        const m = matches.find((x) => x.cartItem.key === item.key);
        if (!m || (isDirect && m.row === first.row)) {
          return;
        }
        m.row.style.setProperty('display', 'none', 'important');
        m.row.dataset.awtomicHidden = 'true';
        const content = m.row.querySelector('.line-item__info-with-line-price');
        if (content) {
          content.style.setProperty('display', 'none', 'important');
        }
      });
    }
  };

  const process = async (context, data) => {
    const ctx = context.type;
    const last = lastData[ctx];
    if (
      last &&
      last.items.length === data.items.length &&
      last.items.every(
        (i, idx) =>
          i.key === data.items[idx].key &&
          i.quantity === data.items[idx].quantity,
      )
    ) {
      return;
    }
    lastData[ctx] = data;
    isProcessing = true;
    lastTime = Date.now();

    try {
      const newTheme = detectTheme();
      if (newTheme.name !== THEME.name) {
        debug(`Theme: ${THEME.name} → ${newTheme.name}`);
        THEME = newTheme;
      }

      const cfg = getConfig(context.theme);
      const containers = cfg.findContainer(context);
      if (!containers.root) {
        return;
      }

      const isDir = ['rebuy', 'supply', 'wonder', 'bls', 'evoi'].includes(
        norm(context.theme),
      );
      if (!isDir) {
        containers.items?.classList.add('awtomic-ready');
        containers.root?.classList.add('awtomic-ready');
      }

      const groups = groupBundles(data);
      if (!Object.keys(groups).length) {
        return;
      }

      // Table themes get rolled up on a COPY of the tbody: the original is left
      // byte for byte as the theme rendered it and only hidden (`awtomic-original`),
      // the copy carries `awtomic-processed`. Mutating the live tbody means every
      // re-render of the cart section fights us, a half-finished run leaves the
      // customer with a broken cart, and re-running has to undo itself row by row.
      // With the copy, re-running is "drop the old copy, build a new one".
      const useClone =
        !isDir && !!containers.items && containers.root.tagName === 'TBODY';

      if (useClone) {
        containers.items
          .querySelectorAll('tbody.awtomic-processed')
          .forEach((el) => el.remove());
      }

      const work = useClone ? containers.root.cloneNode(true) : containers.root;
      if (useClone) {
        work.classList.add('awtomic-processed');
        work.classList.remove('awtomic-original');
      }

      const matches = findMatches(data, work, THEME.selectors, context.theme);
      if (!matches.length) {
        return;
      }

      if (!useClone) {
        const keys = new Set(
          Object.values(groups).flatMap((g) => g.items.map((i) => i.key)),
        );
        for (const row of context.container.querySelectorAll(
          'line-item, tr[data-key]',
        )) {
          const key =
            row.dataset.key ||
            row.querySelector('input[data-line-key]')?.dataset.lineKey;
          if (key && keys.has(key)) {
            row.dataset.awtomicHidden = 'true';
            row.style.setProperty('display', 'none', 'important');
          }
        }

        for (const el of work.querySelectorAll('[data-awtomic-hidden]')) {
          el.removeAttribute('data-awtomic-hidden');
          el.style.removeProperty('display');
        }

        for (const el of work.querySelectorAll(cfg.cleanupSelector)) {
          el.remove();
        }
      }

      await createBundles(groups, matches, context.theme, THEME.selectors, {
        root: work,
        items: containers.items,
      });

      if (useClone) {
        containers.root.classList.add('awtomic-original');
        containers.items.appendChild(work);
      }

      if (isDir) {
        containers.items?.classList.add('awtomic-ready');
        containers.root?.classList.add('awtomic-ready');
      }

      debug(`Rollup done: ${context.type} (${context.theme})`);
    } catch (e) {
      console.error('[Awtomic] Error:', e);
      removeAntiFlicker();
    }
  };

  const analyze = async () => {
    if (isProcessing || Date.now() - lastTime < 1000) {
      return;
    }

    try {
      const contexts = [];

      if (window.rebuyCart) {
        const rebuy = document.querySelector('.rebuy-cart__flyout-items');
        if (rebuy) {
          contexts.push({
            type: 'rebuy',
            theme: 'Rebuy',
            container:
              rebuy.closest('.rebuy-cart__flyout, [data-rebuy-container]') ||
              document,
          });
        }
      }

      if (THEME.drawer) {
        const drawer = document.querySelector(THEME.drawer.selectors);
        const open = drawer && THEME.drawer.visibilityCheck(drawer);
        const items = (open ? drawer : document).querySelector(
          THEME.drawer.itemsComponent,
        );
        // A closed drawer that is still rendered (Dawn keeps its markup in the
        // DOM at all times) is rolled up ahead of time too: opening it then
        // never flashes the un-collapsed cart at the customer.
        if (items && (open || items.offsetParent)) {
          const anchor = open ? drawer : items;
          contexts.push({
            type: 'drawer',
            theme: THEME.name,
            container: anchor.closest(THEME.drawer.closestContainer) || anchor,
          });
        }
      }

      if (window.location.pathname === '/cart' && THEME.name !== 'Fallback') {
        contexts.push({ type: 'page', theme: THEME.name, container: document });
      }

      if (!contexts.length) {
        removeAntiFlicker();
        return;
      }

      const data = await fetchCart();
      if (!data) {
        removeAntiFlicker();
        return;
      }

      for (const ctx of contexts) {
        await process(ctx, data);
      }
      updateCartBubble(data);
      isProcessing = false;
      removeAntiFlicker();
    } catch (e) {
      console.error('[Awtomic] Fatal:', e);
    }
  };

  const observeCart = (selector, callback) => {
    const el = document.querySelector(selector);
    if (!el) {
      return null;
    }
    const obs = new MutationObserver(() => callback());
    obs.observe(el, { childList: true, subtree: true });
    return obs;
  };

  window.addEventListener('load', analyze);
  document.addEventListener('shopify:section:load', analyze);

  if (THEME.drawer?.itemsComponent) {
    observeCart(THEME.drawer.itemsComponent, analyze);
  }

  // A drawer that is already in the DOM and only toggles a class/attribute when
  // it opens (Dawn adds `active` to <cart-drawer>) never mutates its items, so
  // the observer above would not fire: watch the open state as well.
  if (THEME.drawer?.selectors) {
    const drawerState = new MutationObserver((muts) => {
      for (const m of muts) {
        if (THEME.drawer.visibilityCheck(m.target)) {
          analyze();
          break;
        }
      }
    });
    document.querySelectorAll(THEME.drawer.selectors).forEach((el) =>
      drawerState.observe(el, {
        attributes: true,
        attributeFilter: ['open', 'class', 'aria-hidden'],
      }),
    );
  }

  if (typeof window.rebuyCart !== 'undefined') {
    observeCart('.rebuy-cart__flyout-items', analyze);
  }

  window.awtomicCartRollup = { analyze, config, THEME, updateCartBubble };
})();
